import { render, staticRenderFns } from "./DotsIcon.vue?vue&type=template&id=1510a3d6&scoped=true&"
import script from "./DotsIcon.vue?vue&type=script&lang=ts&"
export * from "./DotsIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DotsIcon.vue?vue&type=style&index=0&id=1510a3d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510a3d6",
  null
  
)

export default component.exports